import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, ViewEncapsulation, ComponentFactoryResolver, ViewContainerRef, ComponentRef, OnDestroy, AfterViewInit } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { TrackCoreObject } from '../asp/TrackCoreObject';
import * as aspObjects from '../asp/aspObjects';
import * as aspSettings from '../asp/aspSettings';
import * as enums from '../common/enums';
import * as consts from '../common/consts';
import * as units from '../common/units';
import * as utils from '../common/utils';
import { mainMapMngr } from '../asp/MapMngr';
import { IAro, AppInjector } from '../common/inject';
import { AroService } from './aro.service';
import * as aro from './aro';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import { MatDialogRef } from '@angular/material/dialog';
import { AroTrackComponent } from '../../../app/aro/aro-track.component';
import * as projConsts from '../../../app/common/projConsts';
import * as projMsgs from '../../../app/msg/projMsgs';
import { UserActionService } from '@core_n/user-action/user-action.service';
import * as settings from '../common/settings';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
// import { AroSensorService } from '../../../app/aro/aro-sensor.service';
import { SensorObject } from '../../../app/asp/SensorObject';
import { FormControl } from '@angular/forms';
import { from, ReplaySubject, Subject } from 'rxjs';
import { ClsArmService } from 'src/core/app/asp/cls-arm.service';
import { TrackObject } from 'src/app/asp/TrackObject';
import { Animations } from '@core_n/Animations';

const MAX_SPEED = settings.MAX_SPEED_KNOTS // 700 knots
const MAX_ALT = settings.MAX_ALT_FT // 500 ft

const MISSILE_MAX_SPEED = settings.MISSILE_MAX_SPEED_KNOTS // 5000 knots
const MISSILE_MAX_ALT = settings.MISSILE_MAX_FT; // 25,000 hft

@Component({
  templateUrl: './aro-track-core.component.html',
  styleUrls: ['./aro.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})
export class AroTrackCoreComponent extends ZIndexMngr implements IAro, OnInit, OnDestroy, AfterViewInit {

  //Child Components
  @ViewChild('tabGroup') public tabGroup: MatTabGroup;
  @ViewChild('aroContainer', { read: ElementRef }) private aroContainer: ElementRef;
  @ViewChild('tab2Container', { read: ViewContainerRef }) protected tab2Container: ViewContainerRef;
  // @ViewChild('tab3Container', { read: ViewContainerRef }) protected tab3Container: ViewContainerRef;
  // @ViewChild('tab4Container', { read: ViewContainerRef }) protected tab4Container: ViewContainerRef;
  @ViewChild('minorSelect', { read: MatSelect }) minorSelect: MatSelect;
  @ViewChild('identitySelect', { read: MatSelect }) identitySelect: MatSelect;
  @ViewChild('speedCircle', { read: ElementRef, static: true }) speedCircle: ElementRef;

  // Form Management
  public track: TrackCoreObject = null;
  protected shown: boolean = false;
  public retryThresh: number = 0;
  public planeSymbol: string = "unknown-target";
  public minorValues = []; //?????
  public identities = [];
  public panelopen: boolean = false;

  //Tab Management
  protected tab2ComponentRef: ComponentRef<any>;
  protected tab3ComponentRef: ComponentRef<any>;
  protected tab4ComponentRef: ComponentRef<any>;
  public tab1Label: string = "Overview";
  public tab2Label: string = 'Classiff';
  public tab3Label: string;
  public tab4Label: string;

  // Flat Data of ARO
  public trackType: enums.TrackType = enums.TrackType.Unidentified;
  public trackTypeStr: string = enums.TrackTypeTitle(this.trackType);
  public trackStatus: string = "Normal";
  public nationality: string;
  public altitude: string = aro.NO_VALUE;
  public altitudeUnits: string;
  public speed: string;
  public speedShow: string;
  public speedUnits: string;
  public heading: string;
  public headingRotate: string;
  public location: string;
  public locUnits: string;
  public cls: string;

  // External Track Data
  isExternal: boolean = false;
  externalTN: string = "";
  remoteHostility: string = "";

  //might need this data there is also something on the html side that show all this data...
  public missileStage: string;
  public missileAcceleration: string;
  public missileAccelerationUnits: string;
  public missileSpinRate: string;
  public missileSpinRateUnits: string;
  //??????????

  // new members
  public velocityZ: string = aro.NO_VALUE;
  public velocityZUnits: string = "";
  public velZValid: boolean = false;

  public caspID: string;
  public datetime: Date;
  public time: string = "N/A";
  public age: string = '';

  //Classification
  public systemClass: string = "";

  // TBM Only
  public boostPhase: string = "";
  public maneuver: string = "";

  // ABT Only
  public identityValue: number;
  public identityStr: string;
  public identityColor: string;
  // MODES
  public mode1: string;
  public mode2: string;
  public mode3: string;
  public mode4: string;
  public modeC: string;
  public modeSAcIdent: string;
  public modeSAddress: string;
  public modeSAltitude: string;
  public modeSSpeed: string;

  public speedCircleRadius: number;
  public speedCircleDasharray;
  public speedCircleDashoffset;

  public altPercentGrad1;
  public altPercentGrad2;
  public altPercentActual; // actual altitude percentage
  public altPercentCutoff; // cutoff to transparent
  public altMinOpacity = 0.2;
  public altMaxOpacity = 0;

  public options: FormControl;

  // Classifications

  // List of Classifications
  public classifs: string[] = [""];

  // Platforms
  // list of platforms
  protected platforms: string[] = [""];
  // selected platform
  public classifControl = new FormControl(null);
  public platformControl = new FormControl(null);

  // filter for the matselect filter keyword
  public filteredPlatsCtrl = new FormControl('');
  // list of platforms filtered by search
  public filteredPlats = new ReplaySubject<string[]>(1);

  @ViewChild('platformSelect', { static: true }) pltSelect: MatSelect;
  @ViewChild('clsformSelect', { static: true }) clsSelect: MatSelect;

  // subject that emits when the component is destroyed
  protected _onDestroy = new Subject<void>();

  constructor(
    protected aroService: AroService,
    protected cdref: ChangeDetectorRef,
    elementRef: ElementRef,
    public dialogRef: MatDialogRef<AroTrackComponent>) {
    super(elementRef);

    if (settings.userSettings.userPerm == enums.Permission.USER)
      this.ngOnDestroy();

    let self = this;
    setInterval(function () { self.refresh() }, consts.DIALOG_REFRESH_INTERVAL);
    this.locUnits = enums.CoordinateTypeTitle(settings.userSettings.coordinatesType);
    let identities = enums.HostilityKeys.map(Number);
    for (let ident of identities)
      this.identities.push({ title: enums.HostilityTitle(ident), id: ident });
  }

  ngOnInit(): void {
    this.aroService.setTrackAro(this);
    this.speedCircleRadius = this.speedCircle.nativeElement.r.baseVal.value;
    this.speedCircleDasharray = this.speedCircleRadius * 2.0 * Math.PI;
    this.speedCircleDashoffset = this.speedCircleDasharray;

    // Classification Stuff
    // let clsarmdata = AppInjector.get(ClsArmService).getSelf();
    // this.classifs = clsarmdata.getAllClsCats();
    // // this.classifs.push("None");

    // //load the initial platforms
    // // this.filteredPlats.next(this.platforms.slice());
    // this.filteredPlats.next(null);


    // this.filteredPlatsCtrl.valueChanges
    //   .pipe().subscribe(() => {
    //     this.filterPlats();
    //   });

    // Prevent keyboard manipulation of mat-select, since there is no visible indication it is the current field
    let _this = this;
    document.addEventListener('keydown', e => {
      if ((_this.minorSelect && e.target == _this.minorSelect._elementRef.nativeElement) ||
        (_this.identitySelect && e.target == _this.identitySelect._elementRef.nativeElement))
        e.stopImmediatePropagation();
    }, true);

    // this.pltSelect.value = this.platforms[this.track.oprPlatformIndex];
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
    })
  }

  ngOnDestroy(): void {
    this.dialogClosed();
    this.dialogRef.close();
  }

  // Return factory to create tab 2-4 component
  protected getTabComponentFactory(tabIndex: number) {
    return null;
  }

  protected refresh(force: boolean = false): void {
    if ((this.shown || force) && this.track != null) {
      // Try to set ARO to fixed height
      if (this.aroContainer) {
        let aroContainerElem = this.aroContainer.nativeElement as HTMLElement;
        if (aroContainerElem.offsetHeight > 0 && aroContainerElem.style.minHeight.length == 0)
          aroContainerElem.style.minHeight = `${aroContainerElem.offsetHeight}px`;
      }
      this.cdref.detectChanges();
      if (!this.track.active()) {
        this.track = null;
        this.shown = false;
      }
      else {
        this.retryThresh++;

        this.planeSymbol = this.track.symbol;
        // this.planeSymbol = utils.getPlaneSymbol("radar");

        this.nationality = utils.getNationalityImage(this.track.modeSNationality);
        this.updateLocation();

        this.cls = this.track.cls;

        //ids
        this.caspID = this.track.trackID;
        let typeChange: boolean = false;
        if (this.trackType != this.track.trackType) {
          typeChange = true;
          this.trackType = this.track.trackType;
        }
        this.trackTypeStr = enums.TrackTypeTitle(this.trackType);
        this.trackStatus = enums.TrackStatusTitle(this.track.trackStatus);
        if (this.track.timeStamp) {
          let dtime: Date = this.track.timeStamp;
          // this.time = units.datetime2Str(dtime);
          this.time = dtime.toLocaleString().split(' ')[1];
          this.age = ((Date.now() - this.track.timeStamp.getTime()) / 1000).toFixed(0);
        }

        // Speed
        this.speedUnits = units.speedUnits();
        let spd = units.speedValue(this.track.speed);
        let spdChanged = this.speed != spd;
        if (spdChanged || this.retryThresh < 5 || typeChange) {
          this.speed = spd;
          let speedOffset = (1.0 - this.track.speed / (this.trackType == enums.TrackType.TBM ? MISSILE_MAX_SPEED : MAX_SPEED));
          if (speedOffset < 0)
            speedOffset = 0;
          this.speedCircleDashoffset = this.speedCircleDasharray * speedOffset;
          if (this.track.velocityZ != undefined) {
            this.velZValid = true;
            if (settings.userSettings.displayUnits) { // m/s -> km/h
              this.velocityZ = (this.track.velocityZ * units.METER_SEC_TO_KMH).toFixed(2);
              this.velocityZUnits = units.KMH_LABEL;
              this.speedShow = (this.track.speed * units.METER_SEC_TO_KMH).toFixed(2);
            }
            else { // knots
              this.velocityZ = (this.track.velocityZ * units.METER_SEC_TO_KNOT).toFixed(2);
              this.velocityZUnits = units.KT_LABEL;
              this.speedShow = (this.track.speed * units.METER_SEC_TO_KNOT).toFixed(2);
            }
          }
          else {
            this.velZValid = false;
            if (settings.userSettings.displayUnits) { // m/s -> km/h
              this.speedShow = (this.track.speed * units.METER_SEC_TO_KMH).toFixed(2);
            }
            else {
              this.speedShow = (this.track.speed * units.METER_SEC_TO_KNOT).toFixed(2);
            }
            this.velocityZ = aro.NO_VALUE;
          }
        }

        // Heading
        let hdg = units.headingValue(this.track.heading);
        let hdgChanged = this.heading != hdg;
        if (hdgChanged) {
          this.heading = hdg;
          let hdgGauge = Number.parseFloat(hdg) + 180.0;
          if (hdgGauge > 360)
            hdgGauge -= 360;
          this.headingRotate = `rotate(${hdgGauge}deg)`;
        }

        // Altitude
        if (this.track.geometry.z != undefined) {
          this.altitudeUnits = units.altitudeUnits();
          let altStr = units.altitudeValue(this.track.geometry.z, true);
          let altChanged = this.altitude != altStr;
          if (altChanged || this.retryThresh < 5 || typeChange) {
            this.altitude = altStr;

            let altPercent = Math.round(this.track.geometry.z / (this.trackType == enums.TrackType.TBM ? MISSILE_MAX_ALT : MAX_ALT) * 100.0);
            if (altPercent < 0)
              altPercent = 0;
            else if (altPercent > 100)
              altPercent = 100;

            this.altPercentActual = `${altPercent}%`;
            let altPercentCutoff = altPercent + 0.1;
            if (altPercentCutoff > 100)
              altPercentCutoff = 100;
            this.altPercentCutoff = `${altPercentCutoff}%`;

            let altPercentGrad1, altPercentGrad2;
            if (altPercent >= 20) {
              altPercentGrad2 = altPercent - 10;
              if (altPercentGrad2 < 0)
                altPercentGrad2 = 0;
              altPercentGrad1 = altPercent - 15;
              if (altPercentGrad1 < 0)
                altPercentGrad1 = 0;
            }
            else {
              altPercentGrad2 = altPercent * 0.5;
              altPercentGrad1 = altPercent * 0.25;
            }
            this.altPercentGrad2 = `${altPercentGrad2}%`;
            this.altPercentGrad1 = `${altPercentGrad1}%`;

            this.altMaxOpacity = altPercent == 100 ? 1 : 0;
            this.altMinOpacity = altPercent == 0 ? 0 : 0.2;
          }
        }
        else {
          this.altitude = aro.NO_VALUE;
          this.altitudeUnits = undefined;

          this.altPercentActual = `${0}%`;
          this.altPercentCutoff = `${0}%`;
          this.altPercentGrad2 = `${0}%`;
          this.altPercentGrad1 = `${0}%`;
        }

        // All modes
        this.mode1 = this.track.mode1Valid ? this.track.mode1.toString() : aro.NO_VALUE;
        this.mode2 = this.track.mode2Valid ? this.track.mode2.toString() : aro.NO_VALUE;
        this.mode3 = this.track.mode3Valid ? this.track.mode3.toString() : aro.NO_VALUE;
        this.mode4 = this.track.mode4Valid ? this.mode4 : aro.NO_VALUE;
        this.modeC = this.track.modeCValid ? (utils.modeC2Height(this.track.modeC) * units.METER_TO_FEET / 100.0).toString().padStart(3, '0') : aro.NO_VALUE;
        this.modeSAcIdent = this.track.modeSValid ? this.track.modeSAcIdent.toString() : aro.NO_VALUE;
        this.modeSAddress = this.track.modeSValid ? this.track.modeSAddress.toString() : aro.NO_VALUE;
        this.modeSAltitude = this.track.modeSValid ? this.track.modeSAltitude.toString() : aro.NO_VALUE;
        this.modeSSpeed = this.track.modeSValid ? this.track.modeSSpeed.toString() : aro.NO_VALUE;

        // Identity/Hostility
        // this.identityValue = this.track.hostility;
        this.identityColor = utils.newmiColorToString(this.track.getColor());

        // Classifications
        if (this.classifControl.value != this.track.oprCategory) {
          if (this.track.oprCategory == '')
            this.classifControl.setValue(null);
          else
            this.classifControl.setValue(this.classifs[this.track.oprCategoryIndex]);
          this.onClsSelected({ value: this.classifControl.value })
        }
        // this.pltSelect.value = this.platforms[this.track.oprPlatformIndex];
        if (this.platformControl.value != this.track.oprPlatform) {
          if (this.track.oprPlatform == '')
            this.platformControl.setValue(null);
          else
            this.platformControl.setValue(this.platforms[this.track.oprPlatformIndex]);
        }

        if (this.trackType == enums.TrackType.ABT)
          this.systemClass = this.track.sysCls;

        if (this.trackType == enums.TrackType.TBM) {
          this.boostPhase = this.track.boostPhase ? "TRUE" : "FALSE";
          this.maneuver = this.track.maneuver ? "TRUE" : "FALSE";
        }

        this.isExternal = this.track.isExternal;
        if (this.isExternal) {
          this.externalTN = this.track.externalTN.toString();
          // this.remoteHostility = enums.HostilityTitle(this.track.remoteHostility);
        }
      }
      this.cdref.detectChanges();
    }
    else if (this.shown) {
      this.shown = false;
    }
    else if (this.track == null) {
      this.ngOnDestroy();
    }
  }

  public showAro(objectId): boolean {
    let track = <TrackCoreObject>aspObjects.tracksPool.getObject(objectId);
    if (!track)
      track = <TrackCoreObject>aspObjects.sensorTracksPool.getObject(objectId);
    if (track) {
      this.track = track;
      this.shown = true;
      this.tabGroup.realignInkBar();
      this.refresh(true);
    }
    return track != null;
  }

  public hideAro() {
    this.track = null;
    this.shown = false;
  }

  public isShown(): boolean {
    return this.shown;
  }

  public getShownId() {
    if (this.track == null)
      return null;
    else
      return this.track.id;
  }

  public updateLocation() {
    if (this.shown && this.track)
      this.location = utils.getCoordinatesString(this.track.geometry);
  }

  onCenterBtnClick() {
    if (this.track == null)
      return;
    mainMapMngr.setMapCenter(this.track.geometry);
  }

  onDynamicCenterBtnClick() {
    if (this.track == null)
      return;
    if (this.dynamicCenterActive())
      mainMapMngr.setDynamicCenterId(null);
    else
      mainMapMngr.setDynamicCenterId(this.track.id);
  }

  onHistoryBtnClick() {
    if (this.track == null)
      return;
    this.track.setTrailVisibility(!this.track.isTrailVisible());
  }

  onTMPBtnClick() {
    if (this.track == null)
      return;

    let Msg = new projMsgs.ForbidDeletion();
    Msg.TrackNumber = 123;
    Msg.Forbid = true;
    AppInjector.get(UserActionService).sendUserAction(Msg);
  }

  onDropBtnClick() {
    if (this.track == null)
      return;

    // let dropTrackMsg = new projMsgs.DropTrack();
    // dropTrackMsg.TrackNumber = this.track.trackID;
    // AppInjector.get(UserActionService).sendUserAction(dropTrackMsg);
  }

  dynamicCenterActive() {
    if (!this.shown || this.track == null)
      return false;
    return (mainMapMngr.getDynamicCenterId() == this.track.id);
  }

  historyActive() {
    if (!this.shown || this.track == null)
      return false;
    return this.track.isTrailVisible();
  }

  showMissileData(): boolean {
    return false;
  }

  showFlightProgress(): boolean {
    // return this.isAbt;
    return true;
  }

  // Hostility Selection Handeling
  onHostilitySelected(evt: MatSelectChange) {
    // Change the data on the core track so it wont override local data on next update
    // if this data is false... the core data will be updated from the backend in like 15 secs
    // this.track.hostility = evt.value;
    // this.track.userSetHostility = true;
    // if (this.track.trackType != enums.TrackType.TBM) {
    //   this.track.symbol = enums.HostilityTitle(evt.value);
    // }

    // update local data for immidiate change
    // this.identityValue = evt.value;
    // this.identityStr = enums.HostilityTitle(evt.value);

    // set user selection for hostility value
    // this will override remote hostility...
    this.track.userSetHostility = true;

    // Send Switch Action
    // let SetHostility = new projMsgs.SetHostility();
    // SetHostility.TrackNumber = this.track.trackID;
    // SetHostility.TrackHostility = evt.value;
    // AppInjector.get(UserActionService).sendUserAction(SetHostility);

    let trackobj = this.track as TrackObject;
    trackobj.threatPoly = null;
    trackobj.ip = null;
    trackobj.update();
  }

  // Classification Selection and Filtering Handeling
  protected filterPlats() {
    if (!this.platforms) {
      return;
    }
    //get search keyword
    let search = this.filteredPlatsCtrl.value;
    if (!search) {
      this.filteredPlats.next(this.platforms);
      return;
    }
    else {
      search = search.toLowerCase();
    }
    this.filteredPlats.next(
      this.platforms.filter(plt => plt.toLowerCase().indexOf(search) > -1)
    );
  }

  onClsSelected(evt: any, swa?: boolean) {
    let clsarmdata = AppInjector.get(ClsArmService).getSelf();
    this.platforms = [];
    if (evt.value != undefined) {
      this.platforms = clsarmdata.getAllPlatsOfCat(evt.value);
      // this.track.setClsPlt(evt.value);
      // console.log("cls updated track with: " + evt.value);
    }
    this.filteredPlats.next(this.platforms);
    if (swa) {
      // Send Switch Action
      // let SetCls = new projMsgs.SetClassification();
      // SetCls.TrackNumber = this.track.trackID;
      // SetCls.OperatorCategory = evt.value == undefined ? "" : evt.value;
      // SetCls.OperatorPlatform = "";
      // AppInjector.get(UserActionService).sendUserAction(SetCls);
    }
    // !!! Set Track Data
  }

  onPltSelected(evt: MatSelectChange) {
    // this.track.setClsPlt(this.track.oprCategory, evt.value);

    // Send Switch Action
    // let SetCls = new projMsgs.SetClassification();
    // SetCls.TrackNumber = this.track.trackID;
    // SetCls.OperatorCategory = this.classifControl.value;
    // SetCls.OperatorPlatform = evt.value == undefined ? "" : evt.value;
    // AppInjector.get(UserActionService).sendUserAction(SetCls);

    // !!! Set Track Data
  }

  onMinorSelected(evt: MatSelectChange) { }

  colorOfIdentity(ident: enums.Hostility, handleDisabled: boolean = true) {
    let color = aspSettings.colorOfIdentity(ident);
    if (handleDisabled && ident == enums.Hostility.Pending)
      color = utils.newmiAlphaColor(color, 0.3);
    return utils.newmiColorToString(color);
  }

  getTrackType() {
    return this.trackType;
  }

  setLocationClick() {
    mainMapMngr.activateMapEventsTool(this.onMapEvent.bind(this), [NeWMI.Map.Enums.EMapEvents.MouseDown]);
  }

  private onMapEvent(evt: NeWMI.Map.Events.MouseEvents) {
    let coord = { x: evt.mapPoint.x, y: evt.mapPoint.y };
    mainMapMngr.activateDefaultTool();
  }

  locationClick() {
    this.aroService.locationClick();
    this.locUnits = enums.CoordinateTypeTitle(settings.userSettings.coordinatesType);
  }

  getID() {
    return this.track.id;
  }

  onSenCenterClick(num: number) {
    let snsobj = aspObjects.sensorsPool.getSensorBySensorID(num);
    if (snsobj) {
      mainMapMngr.setMapCenter(snsobj.geometry);
    }
  }

  // onSenAroClick(num: number) {
  //   let snsobj = aspObjects.sensorsPool.getSensorBySensorID(num);
  //   AppInjector.get(AroSensorService).showSensor(snsobj as SensorObject);
  // }
}

var aroTrackComponentFactory;
export function setAroTrackComponentFactory(factory) {
  aroTrackComponentFactory = factory;
}
export function getAroTrackComponentFactory() {
  if (aroTrackComponentFactory == undefined)
    aroTrackComponentFactory = AppInjector.get(ComponentFactoryResolver).resolveComponentFactory(AroTrackCoreComponent);
  return aroTrackComponentFactory;
}


